import { render, staticRenderFns } from "./PerfilSidebar.vue?vue&type=template&id=c2a59f4a&scoped=true&"
import script from "./PerfilSidebar.vue?vue&type=script&lang=js&"
export * from "./PerfilSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PerfilSidebar.vue?vue&type=style&index=0&id=c2a59f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a59f4a",
  null
  
)

export default component.exports